import React, {useState} from "react";
import {connect, useDispatch} from "react-redux";

import Bubble from "./Bubble";
import {selectNode} from "../../../data/actions";

import {PiPlugs, PiPlugsConnected} from "react-icons/pi";

const TreeNode = ({node, others, level, selected_node}) => {
    const [showSubnodes, setShowSubnodes] = useState(true)
    const [hover, setHover] = React.useState(false);

    const dispatch = useDispatch()


    const _onconnection = node && node.onconnection || false

    const levels = node && node.path && node.path.split('.').map(Number) || [];
    const next = others.filter(it => {
        const x = it.path.split('.').map(Number) || []
        return x[level] > 0
            && (level < 3 ? x[level + 1] === 0 : true)
            && x[level - 1] === levels[level - 1]
            && x[level - 2] === levels[level - 2]
            && x[level - 3] === levels[level - 3]
    });

    next.sort(function (a, b) {
        let _a = a.path.split('.').map(Number) || []
        let _b = b.path.split('.').map(Number) || []

        return _a[0] - _b[0] || _a[1] - _b[1] || _a[2] - _b[2] || _a[3] - _b[3]
    });

    const load = node && node.loadstate || 0
    const _color = load === 0 && '#4a4a4a' || load > 0 && load <= 50 && '#661122' || load > 50 && load <= 70 && '#ffe234' || load > 70 && load <= 100 && '#62a82b'

    const _uid = node && node.uid && `V${node.uid.slice(4, 6)}P${node.uid.slice(6)}`
    const _user = node && node.user.replaceAll('http://', '').replace(/:[0-9]+/, '')
    const _prod = node && node.product

    const _title = `${_user || _uid} (${_prod})` // + ` | ${node && node.path} | ${node && node.uid}`

    const hasSubnodes = next.length > 0


    let _m_level = level;
    if(_onconnection) {
        _m_level = _m_level-1
    }

    return (
        <>
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => {dispatch(selectNode(node))}}
                style={{
                    display: "flex",
                    alignItems: "center",
                    margin: 10,
                    paddingLeft: 16*_m_level,
                }}
            >
                {_onconnection && <span style={{
                    width: 16,
                    cursor: "default",
                    color: hover ? '#e3e3e3' : '#bfbfbf',
                    //backgroundColor: "deeppink",
                }}>
                    <PiPlugsConnected/>
                </span>}

                <span
                    onClick={() => {
                        setShowSubnodes(!showSubnodes)
                    }}
                    style={{
                        width: 16,
                        cursor: "pointer",
                        color: hover ? '#e3e3e3' : '#bfbfbf',
                        //backgroundColor: "magenta",
                    }}
                >{hasSubnodes ? showSubnodes ? '-' : '+' : ' '}</span>

                <Bubble color={_color}/>
                <span style={{
                    marginLeft: 8,
                    cursor: "pointer",
                    color: hover ? '#e3e3e3' : '#bfbfbf',
                }}>{_title}</span></div>
            {showSubnodes ? <div>
                {next.map((it) => {
                    return <TreeNode key={it.uid} node={it} others={others} level={level + 1}/>
                })}
            </div> : null}

        </>


    )

}

function mapStateToProps(state, other) {
    return {selected_node: state.root.selected_node}
}

export default connect(mapStateToProps)(TreeNode)